import axios from "axios";
import Config from "@/config";
import authHeader from "@/services/auth-header";

class AclService {
    fetchUserRoles(userId) {
        return axios.get(Config.apiBasePath + '/acl/fetch-user-roles/' + userId, {headers: authHeader()});
    }

    fetchRoleMenus(id) {
        return axios.get(Config.apiBasePath + '/acl/' + id, {headers: authHeader()});
    }

    saveRoleMenus(id, roleMenus) {
        return axios.put(Config.apiBasePath + '/acl/' + id, {menus: roleMenus}, {headers: authHeader()});
    }

    fetchUserRolesAndMenus() {
        return axios.get(Config.apiBasePath + '/acl/get-my-roles-and-menus', {headers: authHeader()});
    }

    fetchRolePermissions(id) {
        return axios.get(Config.apiBasePath + '/acl/permissions/' + id, {headers: authHeader()});
    }

    saveRolePermissions(id, rolePermissions) {
        return axios.put(Config.apiBasePath + '/acl/permissions/' + id, {permissions: rolePermissions}, {headers: authHeader()});
    }

    fetchUserRolesMenusAndPermissions(userId) {
        return axios.get(Config.apiBasePath + '/acl/user-roles-menus-permissions/' + userId, { headers: authHeader()});
    }

    fetchActivityLogs(date) {
        return axios.get(Config.apiBasePath + '/activity-logs', {params: {date}, headers: authHeader()});
    }
}

export default new AclService();
